<template>
    <div class="text-purple-900">
        <modal ref="modal" @close="goBack()" :back="!isWapi">
            <div v-if="instance && !isWapi" class="flex flex-col h-full overflow-y-scroll items-center pb-10 pt-24 bg-white text-gray-600">
                <div class="text-center mx-auto px-5" v-if="!scanned">
                    <h2 class="text-3xl font-bold">
                        {{ $t('scan_the_code_below_using_whatsapp_web_option') }}
                    </h2>
                </div>

                <div class="pt-10">
                    <div class="loader" v-if="loading"></div>

                    <div v-if="scanned" class="text-center pt-5">
                        {{ $t('synchronizing') }}...
                    </div>

                    <div v-if="!loading && qrCode">
                        <qrcode-vue :value="qrCode" :size="200"></qrcode-vue>

                        <div class="mt-10">
                            <connected-devices :display-name="instance.display_name"></connected-devices>

                            <transition name="fade">
                                <modal ref="customize">
                                        <div class="h-full overflow-y-scroll text-gray-600 grid grid-cols-1 z-40">
                                            <div class="bg-white m-10 p-10">
                                                <customize :instance="instance"
                                                           @cancel="$refs.customize.show=false"
                                                           @updated="nameChanged"></customize>
                                            </div>
                                        </div>
                                </modal>
                            </transition>

                            <button class="btn btn-blue mt-5" @click="$refs.customize.open()">Configurar</button>
                        </div>
                    </div>
                </div>
            </div>

            <w-api v-else-if="instance && isWapi" :instance="instance"></w-api>
        </modal>
    </div>
</template>

<style>
canvas {
    margin: auto;
}
</style>

<script>
    import Modal from "../../../components/Modal.vue";
    import {Auth, Zapin} from "@/services/Api";
    import QrcodeVue from 'qrcode.vue'
    import {getSocketUrl} from "@/helpers/general";
    import Customize from "@/views/Dashboard/Instances/Customize.vue";
    import ConnectedDevices from "@/views/Dashboard/Instances/ConnectedDevices.vue";
    import wApi from "@/views/Dashboard/Instances/wApi.vue";

    export default {
        inject: ['alert'],

        components: {
            ConnectedDevices,
            Customize,
            Modal,
            QrcodeVue,
            wApi
        },

        data() {
            return {
                scanned: false,
                loading: false,
                ws_url: getSocketUrl(),
                ws: null,
                qrCode: null,
                autoReconnect: true,
                checking: null,
                instance: null
            }
        },

        mounted() {
            this.$refs.modal.open();

            this.prepareScan();
        },


        computed: {
            isWapi() {
                return this.instance?.configs && this.instance.configs.wapi;
            }
        },

        async beforeUnmount() {
            this.autoReconnect = false;

            if(this.checking)
                clearInterval(this.checking);

            if(this.ws && this.ws.readyState === WebSocket.OPEN) {
                this.ws.close();
            }
        },

        methods: {
            async checkSetupStatus() {
                let checks = 0;

                this.checking = setInterval(async () => {
                    await this.updateInstance(this.instance.token);

                    checks++;

                    if(this.instance.setup_status === 1 || checks >= 60) {
                        this.viewInstance();
                    }
                }, 3000);
            },

            async updateInstance(token) {
                await Zapin
                    .instances()
                    .show(token)
                    .then(res => {
                        this.instance = res.data;
                    })
            },

            nameChanged() {
                this.$refs.customize.close();
                this.ws.close();
            },

            prepareScan() {
                this.loading = true;

                Zapin
                    .instances()
                    .getToken()
                    .then(async (res) => {
                        await this.updateInstance(res.data.token);

                        if (this.instance.configs?.wapi) {
                            this.loading = false;
                            return;
                        }

                        await this.startConnection(this.instance.token);
                    })
                    .catch(err => {
                        if(err.status === 422){
                            this.alert.showValidationErrors(err.data);
                        } else {
                            console.log(err?.data);
                            this.alert.show(this.$t('unknown_error_try_again'));
                        }

                        this.$router.go(-1);
                    })
            },

            async prepareConnection() {
                return new Promise((resolve, reject) => {
                    if(this.ws && this.ws.readyState !== WebSocket.CLOSED) {
                        this.ws.close();
                        delete this.ws
                    }

                    const authToken = Auth.getJwt();

                    this.ws = new WebSocket(this.ws_url + '?token=' + authToken);

                    this.ws.onerror = (e) => {
                        console.error('Error on connection', e)
                        reject(e);
                    }

                    this.ws.onclose = () => {
                        console.log('Connection closed', this.ws.readyState, this.ws.readyState === WebSocket.CLOSED);

                        this.loading = true;

                        if(this.autoReconnect && this.ws.readyState === WebSocket.CLOSED) {
                            setTimeout(() => this.startConnection(this.instance.token), 3000);
                        }
                    }

                    this.ws.onopen = () => {
                        resolve(this.ws);
                    }
                })
            },

            async startConnection(token) {
                const conn = await this.prepareConnection();

                conn.onmessage = (e) => {
                    let data = JSON.parse(e.data);

                    if(data.cmd === 'qrcode-ref') {
                        this.loading = false;

                        this.qrCode = `${data.ref}`;
                    }

                    if(data.cmd === 'qrcode') {
                        this.loading = false;

                        this.qrCode = `${data.data.ref},${data.data.public},${data.data.client_id}`;
                    }

                    if(data.cmd === 'transfer-connection') {
                        this.ws_url = data.url;
                        this.loading = true;
                        this.qrCode = null;

                        if (window.whatsapp.readyState === WebSocket.OPEN) {
                            this.autoReconnect = true;

                            conn.close()
                        }
                    }

                    if(data.cmd === 'qrcode-ready') {
                        this.scanned = true;
                        this.loading = true;
                        this.autoReconnect = false;

                        conn.close();

                        this.checkSetupStatus();
                    }
                }

                conn.send(JSON.stringify({
                    cmd: 'initialize',
                    token: token
                }));
            },

            async goBack() {
                this.$router.go(-1);
            },

            viewInstance() {
                this.$router.push({
                    name: 'Dashboard'
                });
            }
        }

    }
</script>
